import React, { useState } from 'react';
import BookModal from './BookModal';

function statusClass(stageOrStatus) {
    const v = (stageOrStatus || '').toLowerCase();
    if (v === 'final') return 'status-final';
    if (v.includes('draft')) return 'status-draft-1';
    if (v === 'coming soon') return 'status-coming-soon';
    if (v) return 'status-work-in-progress';
    return '';
}

export default function BookShelf({ series, signedIn, onSignIn, onSeriesClick }) {
    const [selectedBook, setSelectedBook] = useState(null);
    const [selectedSeries, setSelectedSeries] = useState(null);
    const [bookModalOpen, setBookModalOpen] = useState(false);

    const openBook = (book, s) => {
        setSelectedBook(book);
        setSelectedSeries(s);
        setBookModalOpen(true);
    };

    if (!series.length) {
        return (
            <div style={{ textAlign: 'center', padding: '48px 0', color: 'var(--ink-3)', fontSize: 13 }}>
                No series available.
            </div>
        );
    }

    return (
        <>
            <div className="shelves">
                {series.map(s => {
                    const accentCls = 'accent-' + (s.accent || 'sky');
                    const books = s.books || [];
                    const stage = s.status || s.stage || '';

                    return (
                        <div key={s.id || s.title} className={`series-shelf ${accentCls}`}>
                            <div className="series-hd">
                                <div>
                                    <div className="series-genre-label">{s.genre}</div>
                                    <h3 className="series-title-text">{s.title}</h3>
                                </div>
                                <div className="series-hd-right">
                                    {stage && (
                                        <span className={'status-pill ' + statusClass(stage)}>{stage}</span>
                                    )}
                                    <span className="series-count-label">
                                        {s.count ?? books.length}&nbsp;
                                        {(s.count ?? books.length) === 1 ? 'volume' : 'volumes'}
                                    </span>
                                </div>
                            </div>

                            {(s.blurb || s.description) && (
                                <p className="series-blurb-text">{s.blurb || s.description}</p>
                            )}

                            <div className="shelf-wrap">
                                <div className="shelf">
                                    <div className="bookend" />
                                    {books.length === 0 ? (
                                        <div className="spine" onClick={() => onSeriesClick(s)}>
                                            <div className="spine-inner">
                                                <span className="spine-status-text">Coming soon</span>
                                                <span className="spine-title-text">{s.title}</span>
                                            </div>
                                            <div className="spine-card">
                                                <div className="spine-card-meta">{s.genre}</div>
                                                <h4>{s.title}</h4>
                                                <p>{s.blurb || s.description || 'Details to be announced.'}</p>
                                                <span className="link-arrow">View series →</span>
                                            </div>
                                        </div>
                                    ) : (
                                        books.map((book, i) => {
                                            const locked = !signedIn && (book.loginRequired || book.gated);
                                            return (
                                                <div
                                                    key={book.id || i}
                                                    className={'spine' + (locked ? ' is-locked' : '')}
                                                    onClick={() => openBook(book, s)}
                                                >
                                                    <div className="spine-inner">
                                                        <span className="spine-status-text">
                                                            {book.stage || book.status || ''}
                                                        </span>
                                                        <span className="spine-title-text">{book.title}</span>
                                                        {locked && <span className="spine-lock-glyph">⚿</span>}
                                                    </div>
                                                    <div className="spine-card">
                                                        <div className="spine-card-meta">{s.genre}</div>
                                                        <h4>{book.title}</h4>
                                                        <p>{book.description || s.blurb || s.description || ''}</p>
                                                        {locked ? (
                                                            <button
                                                                className="link-arrow"
                                                                onClick={e => { e.stopPropagation(); onSignIn(); }}
                                                            >
                                                                Sign in to read →
                                                            </button>
                                                        ) : (
                                                            <span className="link-arrow">View details →</span>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                    <div className="bookend" />
                                </div>
                                <div className="shelf-plank" />
                                <div className="shelf-caption">
                                    {s.title} — {s.count ?? books.length}&nbsp;
                                    {(s.count ?? books.length) === 1 ? 'volume' : 'volumes'}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <BookModal
                isOpen={bookModalOpen}
                onClose={() => { setBookModalOpen(false); setSelectedBook(null); setSelectedSeries(null); }}
                book={selectedBook}
                series={selectedSeries}
                isGuest={!signedIn}
                onSignIn={() => { setBookModalOpen(false); onSignIn(); }}
            />
        </>
    );
}
